import ReviewSimpleView from './ReviewSimpleView'

export default ReviewSimpleView
